import { ReactElement } from 'react';
import { PatientCentralIframe } from '../../shared/PatientCentralIframe';

export function SchedulerTab(): ReactElement {
  return (
    <PatientCentralIframe
      url="https://retool.bariendo.com/apps/dc09217a-fc49-11f0-8620-ef0c778e05de/Patient%20Central/%5BMedplum%5D%20Scheduling/scheduler?_embed=true"
      title="Procedure Scheduler"
    />
  );
}
